/**
 * Arabic Quote Translations
 * 报价弹窗翻译模块 - 阿拉伯语
 * 
 * 包含获取报价表单和弹窗等翻译
 */

import type { QuoteTranslations } from '../../types';

export const arQuote: QuoteTranslations = {
  getQuote: 'احصل على عرض أسعار',
  title: 'احصل على عرض أسعار مجاني',
  modal: {
    title: 'احصل على عرض أسعار مجاني',
    subtitle: 'املأ التفاصيل أدناه وسوف نعود إليك خلال 24 ساعة.',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    productInterest: 'المنتج المهتم به',
    message: 'الرسالة',
    placeholderName: 'محمد أحمد',
    placeholderEmail: 'ahmed@example.com',
    placeholderPhone: '+966-50-000-0000',
    placeholderProduct: 'مثال: سخان صناعي',
    placeholderMessage: 'تفاصيل المشروع، الكمية، متطلبات الجهد...',
    submit: 'إرسال الطلب',
    successTitle: 'تم استلام الطلب!',
    successMessage: 'شكراً لاهتمامك. سيقوم أحد متخصصي التدفئة لدينا بمراجعة متطلباتك والاتصال بك قريباً.',
    close: 'إغلاق',
  },
  name: 'اسمك',
  email: 'البريد الإلكتروني',
  phone: 'رقم الهاتف',
  company: 'اسم الشركة',
  message: 'الرسالة',
  submit: 'إرسال الطلب',
  success: 'شكراً لك! سنقوم بالتواصل معك قريباً.',
};
